import * as React from 'react';

import { createIcon } from '../Icon';
export const ChevronRightIcon = createIcon(
  <polyline points="9 18 15 12 9 6" />,
  'ChevronRightIcon'
);
